import { NgModule } from '@angular/core';
import { PaymentApiService } from './services/payment.api.service';
import { CurrencyApiService } from './services/currency.api.service';
import { PaymentStoreReducer } from './store/payment.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { PaymentStoreEffects } from './store/payment.effects';
import { PaymentStoreService } from './store/payment.store.service';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { paymentFeatureKey } from './store/payment.state';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    RouterModule,
    SharedModule,
    StoreModule.forFeature(paymentFeatureKey, PaymentStoreReducer),
    EffectsModule.forFeature([PaymentStoreEffects]),
  ],
  providers: [PaymentApiService, CurrencyApiService, PaymentStoreEffects, PaymentStoreService],
})
export class PaymentClientModule {}
